import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type OrderFormJsonEditService = {
  payload: {
    orderId: number
  }
}

export const orderFormJsonEditService = async ({
  payload,
}: OrderFormJsonEditService): Promise<ResponseAPI> => {
  const response = await api.get(`alterapedido/${payload.orderId}`)

  return response.data
}
